import { z } from 'zod';

export const ticketReconciliationExportParametersSchema = z.strictObject({
	filters: z
		.array(
			z.union([
				z.strictObject({
					propertyName: z.enum(['facilityName', 'facilityNumber']),
					op: z.literal('contains'),
					value: z.string(),
				}),
				z.strictObject({
					propertyName: z.literal('reportDate'),
					op: z.enum(['equals', 'gt', 'gte', 'lt', 'lte']),
					value: z.iso.date(),
				}),
			]),
		)
		.default([]),
	order: z
		.strictObject({
			field: z.enum([
				'reportDate',
				'facilityNumber',
				'facilityName',
				'total',
				'ticketsCollected',
				'ticketsExpected',
				'variance',
			]),
			sort: z.enum(['asc', 'desc']),
		})
		.default({ field: 'reportDate', sort: 'desc' }),
});

export type TicketReconciliationExportParameters = z.infer<typeof ticketReconciliationExportParametersSchema>;
